<template>
    <section class="gmp-section gmp-mb-l">

        <div class="two-column-text">
            <div class="h-c-page">

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                精准控制库存
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    后厨工作人员对库存有最直接的了解，他们可以根据实际使用情况调整库存数据。
                                    这种设计能够确保库存数据的准确性，避免因数据偏差导致的过度或不足采购。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                提高运营效率
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>
                                    后厨人员直接参与库存管理和订货，减少了沟通和审批的环节，使订货流程更为简化和高效。
                                    订单能够更快速地生成并传达给供应商，缩短了订货时间。
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="two-column-text__row">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--4 h-c-grid__col-l--offset-1 two-column-text__content--left">
                            <h3 class="h-c-headline h-c-headline--one">
                                实时数据分析
                            </h3>
                        </div>
                        <div class="h-c-grid__col h-c-grid__col-l--5 h-c-grid__col-l--offset-1 two-column-text__content--right">
                            <div class="h-u-mb-std two-column-text__description">
                                <p>系统提供的实时数据分析功能可以让管理层快速掌握门店运营情况，
                                    如销售趋势、库存水平和成本变动，从而快速做出决策，调整运营策略，提高响应市场变化的能力。</p>
                            </div>
                        </div>
                    </div>

                </div>








            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "EB_two_column_text"
    }
</script>

<style lang="less">


</style>